import { locales, recursiveMerge } from '@/plugins/xtpgui';

export default recursiveMerge(locales.ptBR, {
    'customer.title'    : 'Cadastro de Fornecedor',
    'customer.search'   : 'Localizar',
    'customer.edit'     : 'Editar',
    
    'countries.search'  : 'Localizar',
    'countries.edit'    : 'Editar',
    'countries.title'   : 'Cadastro de País',
    

    
    $vuetify: {},
    
    $dataTable: {},
});